import { Injectable } from '@angular/core';
import { InvUploadHeaderResponse, InvUploadHeaderRowData } from '../pages/inv-upload-component/models/inv-upload.model';

@Injectable({
  providedIn: 'root'
})
export class InvUploadMapperService {

  constructor() { }

  toInvUploadHeaderRowData(headers: InvUploadHeaderResponse[]): InvUploadHeaderRowData[] {
      if(headers == null || headers.length == 0){
        return [];
      } else {
        return headers.map((header, index) => {
          return {
            ...header,
            seqNo: index + 1
          };
        });
    }
  }
}
